export default __webpack_public_path__ + "static/brian-bitmoji-3ef96f666588a53962494cb99e1f1052.png";